import Moment from "moment";

export default class Format{

	static formatDate(dateString){
		try{
			let date = new Moment(dateString);
			return date.format("MM/DD/YYYY");
		}
		catch{
			return "";
		}
	}

	static randomString(length = 5){
		var result           = '';
		var characters       = 'abcdefghijklmnopqrstuvwxyz';
		var charactersLength = characters.length;
		for ( var i = 0; i < length; i++ ) {
			result += characters.charAt(Math.floor(Math.random() *
				charactersLength));
		}
		return result;
	}

    static shortDate(dateString){
        try{
            let date = new Moment(dateString);
            return date.format("MM/DD");
        }
        catch{
            return "";
        }
    }

	static randomString(length = 5){
		var result           = '';
		var characters       = 'abcdefghijklmnopqrstuvwxyz';
		var charactersLength = characters.length;
		for ( var i = 0; i < length; i++ ) {
			result += characters.charAt(Math.floor(Math.random() *
				charactersLength));
		}
		return result;
	}

}
